import { atom } from "recoil";

export const queryParamsState = atom({
    key: 'queryParams',
    default: null
})

export const dateReservationCanceledState = atom({
    key: 'dateReservationCanceled',
    default: null
})

export const agendamientoInconclusoState = atom({
    key: 'agendaInconclusa',
    default: {
        agiRut: null,
        agiFechaBuscada: null,
        ptdRut: null,
        agpCorrel: null,
        aseCorrel: null,
        exaCorrel: null,
        empCodigo: null,
        sueCorrel: null,
        tapTipo: null,
        espCodigo: null,
        isaCodigo: null,
        agiTipo: null
    },
    effects_UNSTABLE: [
        ({ onSet }) => {
            onSet(newValue => {
                console.log("Agendamiento Inconcluso State => ", newValue);
                
            })
        }
    ]
})